export const music = state => {
    return state.music
}

export const modals = state => {
    return state.modals
}

export const game = state => {
    return state.game
}